import _regeneratorRuntime from "babel-runtime/regenerator";
import _toConsumableArray from "babel-runtime/helpers/toConsumableArray";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import * as utils from "@/tools/util";
import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import bizBenefitMethod from "@/business/businessTools/bizBenefitMethod";
import tools from "../QS420_tools";
import GROUP_INFO from "@/business/businessFile/QS421/QS421_groupInfo.js";

var MODULE_ID = "";

var GROUP_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";
var BENEFICIARY_INFO_LIST = "BIZ_DATA.BENEFICIARY_INFO_LIST";
var BENEFICIARY_ARR = [GROUP_INFO.CONTROLER.BENEFICIARY_1, GROUP_INFO.CONTROLER.BENEFICIARY_0, GROUP_INFO.CONTROLER.BENEFICIARY_2, GROUP_INFO.CONTROLER.BENEFICIARY_3, GROUP_INFO.CONTROLER.BENEFICIARY_4];


var backfillOldData = function backfillOldData(_this) {
  var controlBeneficiaryInfo = _.cloneDeepGet(_this, "oppBusiData.oldBusiData.controlBeneficiaryInfo");
  if (!_.isEmpty(controlBeneficiaryInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], controlBeneficiaryInfo);
  }
};

var backfillHistoryDataBeneficiaryModule = function backfillHistoryDataBeneficiaryModule(_this) {
  var controlBeneficiaryInfo = _.cloneDeepGet(_this.historyData, BENEFICIARY_INFO_LIST);
  if (!_.isEmpty(controlBeneficiaryInfo)) {
    _this.$blMethod.parseMoudleArray(_this, _this.groupDatas[GROUP_ID][MODULE_ID], controlBeneficiaryInfo);
  }
  _.each(_this.groupDatas[GROUP_ID][MODULE_ID], function (item, index) {
    if (item.FIELDS.BENEFICIARY_TYPE && !bizBenefitMethod.getFilterFieldDict().includes(item.FIELDS.BENEFICIARY_TYPE.DEFAULT_VALUE)) {
      item.FIELDS.BENEFICIARY_TYPE.DEFAULT_VALUE = "";
      item.FIELDS.BENEFICIARY_TYPE.correct = false;
    }
    item.FIELDS.BENEFICIARY_TEL.VALID_TYPE = "mobileortel";
    item.FIELDS.SHARE_RATIO.unitText = "%";
    item.FIELDS.NATION.FIELD_TYPE = "selector";
    item.FIELDS.IS_SAME_LEGAL_REP && (item.FIELDS.IS_SAME_LEGAL_REP.FIELD_CONTROL = "0");
    item.FIELDS.BENEFICIARY_ID_TYPE && (item.FIELDS.BENEFICIARY_ID_TYPE.FIELD_DICT_NAME = _.filter(item.FIELDS.BENEFICIARY_ID_TYPE.FIELD_DICT_NAME, function (item) {
      return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "0";
    }));
    if (index > 0) {
      item.FIELDS.IS_SAME_LEGAL_REP && (item.FIELDS.IS_SAME_LEGAL_REP.FIELD_CONTROL = "1");
    }
  });
};

var backfillHistoryData = function backfillHistoryData(_this) {
  if (_this.userType === "1") {
    backfillHistoryDataBeneficiaryModule(_this);
    return;
  }
  var proCls = _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_CLS.DEFAULT_VALUE;
  var controlBeneficiaryInfo = _.cloneDeepGet(_this.historyData, BENEFICIARY_INFO_LIST);
  var benefitListObj = bizBenefitMethod.getFilterBenefitListObj(controlBeneficiaryInfo);
  if (bizBenefitMethod.isTrustProducts(proCls)) {
    _.each(BENEFICIARY_ARR, function (moduleObj) {
      var controlBeneficiaryInfo = benefitListObj[moduleObj.MODULE_ID];
      if (!_.isEmpty(controlBeneficiaryInfo)) {
        _this.$blMethod.parseMoudleArray(_this, _this.groupDatas[GROUP_ID][moduleObj.MODULE_ID], controlBeneficiaryInfo);
      }
    });
  } else {
    backfillHistoryDataBeneficiaryModule(_this);
  }
};

var setFeildData = function setFeildData(fieldData, fieldAction, val, filterArr) {
  _.each(fieldData, function (item) {
    if (filterArr.indexOf(item.FIELD_ID) == -1) {
      item[fieldAction] = val;
    };
  });
};

var initFieldConfig = function initFieldConfig(_this) {
  _this.userType === "2" && bizBenefitMethod.initializeBeneficiaryModules(_this);
  var beneficiaryAllArr = bizBenefitMethod.BENEFICIARY_ALL_ARR;
  _.each(beneficiaryAllArr, function (module) {
    var modules = _.get(_this, module);
    _.each(modules, function (item) {
      var fields = item.FIELDS;
      fields.IS_SAME_LEGAL_REP && (fields.IS_SAME_LEGAL_REP.FIELD_TYPE = "radio");
      fields.IS_SAME_LEGAL_REP && (fields.IS_SAME_LEGAL_REP.FIELD_CONTROL = "1");
      fields.BENEFICIARY_TEL.VALID_TYPE = "mobileortel";
      fields.BENEFICIARY_ID_TYPE.FIELD_DICT_NAME = _.filter(fields.BENEFICIARY_ID_TYPE.FIELD_DICT_NAME, function (item) {
        return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "0";
      });
      fields.SHARE_RATIO.unitText = "%";
      _.set(fields, "NATION.FIELD_TYPE", "selector");

      fields.IS_UPLOAD_IMG.DEFAULT_VALUE = "0";
    });
  });
};

var changeLegalTile = function changeLegalTile(_this, titleValue) {
  var str = "groupDatas.CONTROLER_INFO_PAGE.";
  var moduleArr = ["CONTROLER_MODULE1", "CONTROLER_MODULE", "CONTROLER_MODULE2", "BENEFICIARY_MODULE"];
  _.each(moduleArr, function (item) {
    var fd = _.get(_this, str + item + "[0].FIELDS.IS_SAME_LEGAL_REP");
    if (fd) {
      fd.FIELD_TITLE = titleValue;
    }
  });
};

var productBeforeSave = function productBeforeSave(_this, params) {
  _.each(BENEFICIARY_ARR, function (moduleObj) {
    var moduleData = bizPublicSaveMethod.getModuleObjctFoyKey(_this, moduleObj.MODULE_ID, [moduleObj.SAVE_PATH], true);
    if (!_.isArray(moduleData)) {
      moduleData = [moduleData];
    }
    _.each(moduleData, function (item) {
      item.CONTROLER_EMAIL = "";
      item.POLICE_FLAG = "0";
      item.POLICE_CHECK_SNO = "";
      item.POLICE_VALID_RESULT = "";
      item.POLICE_UNCHECK_REASON = "";
      item.POLICE_OTHER_UNCHECK_REASON = "";
      item.BENEFICIARY_RELA = "";
      item.NOT_CHECK = item.withoutChecked ? "1" : "0";
    });

    bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [moduleObj.SAVE_PATH], moduleData);

    _.set(params, "" + moduleObj.SAVE_PATH, moduleData);
  });
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);

    if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
      backfillOldData(_this);
    }
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
    _this.oppBusiData.isTrustProductsHis = _.get(_this, "historyData.DETAIL_DATA.isTrustProducts");
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var beneficiary1, beneficiary0, beneficiary2, beneficiary3, beneficiary4, controlInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.userType === "2" && bizBenefitMethod.isTrustProducts(_this.groupDatas.PRODUCT_INFO_PAGE && _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_CLS.DEFAULT_VALUE)) {
                productBeforeSave(_this, params);
                beneficiary1 = _.get(params, GROUP_INFO.CONTROLER.BENEFICIARY_1.SAVE_PATH);
                beneficiary0 = _.get(params, GROUP_INFO.CONTROLER.BENEFICIARY_0.SAVE_PATH);
                beneficiary2 = _.get(params, GROUP_INFO.CONTROLER.BENEFICIARY_2.SAVE_PATH);
                beneficiary3 = _.get(params, GROUP_INFO.CONTROLER.BENEFICIARY_3.SAVE_PATH);
                beneficiary4 = _.get(params, GROUP_INFO.CONTROLER.BENEFICIARY_4.SAVE_PATH);

                _.set(params, BENEFICIARY_INFO_LIST, [].concat(_toConsumableArray(beneficiary1), _toConsumableArray(beneficiary0), _toConsumableArray(beneficiary2), _toConsumableArray(beneficiary3), _toConsumableArray(beneficiary4)));
              } else {
                controlInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [BENEFICIARY_INFO_LIST], true);

                if (!_.isArray(controlInfo)) {
                  controlInfo = [controlInfo];
                }
                _.each(controlInfo, function (item) {
                  item.CONTROLER_EMAIL = "";
                  item.POLICE_FLAG = "0";
                  item.POLICE_CHECK_SNO = "";
                  item.POLICE_VALID_RESULT = "";
                  item.POLICE_UNCHECK_REASON = "";
                  item.POLICE_OTHER_UNCHECK_REASON = "";
                  item.BENEFICIARY_RELA = "";
                });
                bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [BENEFICIARY_INFO_LIST], controlInfo);

                _.set(params, BENEFICIARY_INFO_LIST, controlInfo);
              }
              params.DETAIL_DATA.isShowBeneficiaryTypeAlert = "0";
              params.DETAIL_DATA.isTrustProducts = _this.oppBusiData.isTrustProducts;
              params.BENEFICIARY_TYPES = _.pluck(params.BIZ_DATA.BENEFICIARY_INFO_LIST, "BENEFICIARY_TYPE") || [];
              params.HAS_UPLOAD_IMG = !!_.find(params.BIZ_DATA.BENEFICIARY_INFO_LIST, function (obj) {
                return "1" === obj.IS_UPLOAD_IMG && "l" !== obj.BENEFICIARY_TYPE;
              }) ? "1" : "0";
              if (params && params.BIZ_DATA && params.BIZ_DATA) {
                bizBenefitMethod.BENEFICIARY_PRODUCT_ARR.forEach(function (key) {
                  var moduleID = key.split(".").pop();
                  delete params.BIZ_DATA[moduleID];
                });
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),

  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      var address, checkAddrFlag, moduleArr;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              address = [];
              checkAddrFlag = false;
              moduleArr = _this.userType === "1" || !bizBenefitMethod.isTrustProducts(_this.groupDatas.PRODUCT_INFO_PAGE && _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_CLS.DEFAULT_VALUE) ? _this.groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE : [].concat(_toConsumableArray(_this.groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE_1), _toConsumableArray(_this.groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE_0), _toConsumableArray(_this.groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE_2), _toConsumableArray(_this.groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE_3), _toConsumableArray(_this.groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE_4));

              _.each(moduleArr, function (moduleItem) {
                if (moduleItem.FIELDS && moduleItem.FIELDS.BENEFICIARY_ADDR && moduleItem.FIELDS.BENEFICIARY_ADDR.DEFAULT_VALUE && !tools.checkAddress(moduleItem.FIELDS.BENEFICIARY_ADDR.DEFAULT_VALUE)) {
                  address.push(moduleItem.FIELDS.BENEFICIARY_ADDR.DEFAULT_VALUE);
                  checkAddrFlag = true;
                }
              });

              if (!checkAddrFlag) {
                _context2.next = 8;
                break;
              }

              _this.oppBusiData.validateResArr.push({
                alertType: "confirm",
                messageText: "\u8054\u7CFB\u5730\u5740\u672A\u7CBE\u786E\u5230\u95E8\u724C\u53F7\uFF0C\u8BF7\u786E\u8BA4\u8054\u7CFB\u5730\u5740\uFF1A\u3010" + address.join(";") + "\u3011\u4E3A\u771F\u5B9E\u7684\u3001\u53EF\u8054\u7CFB\u5230\u53D7\u76CA\u4EBA\u7684\u5E38\u7528\u5730\u5740\uFF0C\u53EF\u6B63\u5E38\u63D0\u4EA4\u3002"
              });
              _context2.next = 9;
              break;

            case 8:
              return _context2.abrupt("return", true);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {
    var FIELD_DICT_FILTER = [],
        flag = _this.oppBusiData.isShowBeneficiaryTypeAlert === "1";
    if (flag) {
      _this.oppBusiData.isShowBeneficiaryTypeAlert = "0";
      _this.alert((_this.userType === "1" ? "机构" : "产品") + "类别修改后需重新选择【判断受益人方式】");
    }
    if (_this.userType === "1") {
      FIELD_DICT_FILTER = bizBenefitMethod.getFilterFieldDict();
      _.each(_this.groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE, function (mdd) {
        mdd.FIELDS.BENEFICIARY_TYPE.FIELD_DICT_FILTER = FIELD_DICT_FILTER;
        if (flag && mdd.FIELDS.BENEFICIARY_TYPE.DEFAULT_VALUE != "") {
          mdd.FIELDS.BENEFICIARY_TYPE.DEFAULT_VALUE = "";
        }
      });
    } else {
      var proCls = _this.groupDatas.PRODUCT_INFO_PAGE.BASE_INFO[0].FIELDS.PRO_CLS.DEFAULT_VALUE;
      bizBenefitMethod.changeProCls(_this, proCls, flag);
    }

    for (var mdId in _this.moduleDatas) {
      var md = _this.moduleDatas[mdId][0];
      var fieldData = md.FIELDS;
      var field = fieldData.IS_SAME_LEGAL_REP;
      field && (field.FIELD_TYPE = "radio");
      fieldData.BENEFICIARY_ID_TYPE && (fieldData.BENEFICIARY_ID_TYPE.FIELD_DICT_NAME = _.filter(fieldData.BENEFICIARY_ID_TYPE.FIELD_DICT_NAME, function (item) {
        return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "0";
      }));
      _this.busiLogic.CHECK_IS_SAME_LEGAL_REP(_this, field, fieldData, md, true);
    }
    var szOrgType = _.get(_this, "historyData.BIZ_DATA.BASE_INFO.SZORG_TYPE");
    var legal_rep = "groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE",
        legal_rep_fields = "groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS";
    if (["21", "22", "23", "25a"].indexOf(szOrgType) > -1) {
      if (_this.$syscfg.isProOpenAcctBiz(_this.busiCode)) {
        _.set(_this, legal_rep + "[0].MODULE_TITLE", "管理人执行事务合伙人");
      } else {
        _.set(_this, legal_rep + "[0].MODULE_TITLE", "执行事务合伙人");
      }

      _.set(_this, legal_rep_fields + ".LEGAL_REP.FIELD_TITLE", "执行事务合伙人");
      changeLegalTile(_this, "是否同执行事务合伙人");
    } else {
      if (_this.$syscfg.isProOpenAcctBiz(_this.busiCode)) {
        _.set(_this, legal_rep + "[0].MODULE_TITLE", "管理人法定代表人");
      } else {
        _.set(_this, legal_rep + "[0].MODULE_TITLE", "法定代表人");
      }
      _.set(_this, legal_rep_fields + ".LEGAL_REP.FIELD_TITLE", "法定代表人");
      changeLegalTile(_this, "是否同法定代表人");
    }
  },
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},

  "CHECK_IS_SAME_LEGAL_REP": function CHECK_IS_SAME_LEGAL_REP(_this, field, fieldData, md, noClean, isAuto) {
    if (md != null) {
      if (md.MODULE_ID == "CONTROLER_MODULE1" || md.MODULE_ID == "CONTROLER_MODULE2") {
        if (field.DEFAULT_VALUE != "") {
          if (field.DEFAULT_VALUE == "1") {
            setFeildData(fieldData, "FIELD_CONTROL", "1", ["IS_SAME_LEGAL_REP"]);
            fieldData.CONTROLER_NAME && (fieldData.CONTROLER_NAME.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP.DEFAULT_VALUE);
            fieldData.CONTROLER_ID_TYPE && (fieldData.CONTROLER_ID_TYPE.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP_ID_TYPE.DEFAULT_VALUE);
            _this.$nextTick(function () {
              fieldData.CONTROLER_ID_NO && (fieldData.CONTROLER_ID_NO.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP_ID_CODE.DEFAULT_VALUE);
            });
            fieldData.CONTROLER_ID_EXP_DATE && (fieldData.CONTROLER_ID_EXP_DATE.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP_ID_EXP_DATE.DEFAULT_VALUE);
          } else {
            setFeildData(fieldData, "FIELD_CONTROL", "0", ["IS_SAME_LEGAL_REP"]);
            noClean == "0" && _this.$blMethod.parsefieldsDefaultValueToNull(md, ["IS_SAME_LEGAL_REP"]);
          }
        }
      }

      if (md.MODULE_ID == "CONTROLER_MODULE") {
        if (field.DEFAULT_VALUE != "") {
          if (field.DEFAULT_VALUE == "1") {
            setFeildData(fieldData, "FIELD_CONTROL", "1", ["IS_SAME_LEGAL_REP", "CONTROLER_TEL"]);
            fieldData.CONTROLER_NAME && (fieldData.CONTROLER_NAME.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP.DEFAULT_VALUE);
            fieldData.CONTROLER_ID_TYPE && (fieldData.CONTROLER_ID_TYPE.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP_ID_TYPE.DEFAULT_VALUE);
            _this.$nextTick(function () {
              fieldData.CONTROLER_ID_NO && (fieldData.CONTROLER_ID_NO.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP_ID_CODE.DEFAULT_VALUE);
            });
            fieldData.CONTROLER_ID_EXP_DATE && (fieldData.CONTROLER_ID_EXP_DATE.DEFAULT_VALUE = _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS.LEGAL_REP_ID_EXP_DATE.DEFAULT_VALUE);
          } else {
            setFeildData(fieldData, "FIELD_CONTROL", "0", ["IS_SAME_LEGAL_REP"]);
            noClean == "0" && _this.$blMethod.parsefieldsDefaultValueToNull(md, ["IS_SAME_LEGAL_REP", "CONTROLER_TEL"]);
          }
        }
      }

      if (md.MODULE_ID == "BENEFICIARY_MODULE") {
        if (field.DEFAULT_VALUE != "" && md.MODULE_CONTROL === "1" && noClean !== true && isAuto !== "1") {
          fieldData.IS_UPLOAD_IMG && (fieldData.IS_UPLOAD_IMG.DEFAULT_VALUE = "0");
          if (field.DEFAULT_VALUE === "1") {
            if (!fieldData.BENEFICIARY_TYPE || fieldData.BENEFICIARY_TYPE && !fieldData.BENEFICIARY_TYPE.DEFAULT_VALUE) {
              alert("请先选择判定受益人方式");
              fieldData.BENEFICIARY_TYPE.FIELD_CONTROL = "0";
              field.DEFAULT_VALUE = "";
              return;
            }
            if ("l" === fieldData.BENEFICIARY_TYPE.DEFAULT_VALUE) {
              alert("判定受益人方式选择了豁免识别，无法再选择是同法定代表人");
              field.DEFAULT_VALUE = "0";
              return;
            }

            var legalFields = _this.groupDatas.OTHER_INFO_PAGE.LEGAL_MODULE[0].FIELDS;
            fieldData.BENEFICIARY_NAME && (fieldData.BENEFICIARY_NAME.DEFAULT_VALUE = legalFields.LEGAL_REP.DEFAULT_VALUE);
            fieldData.BENEFICIARY_ID_TYPE && (fieldData.BENEFICIARY_ID_TYPE.DEFAULT_VALUE = legalFields.LEGAL_REP_ID_TYPE.DEFAULT_VALUE);
            fieldData.BENEFICIARY_EXP_DATE && (fieldData.BENEFICIARY_EXP_DATE.DEFAULT_VALUE = legalFields.LEGAL_REP_ID_EXP_DATE.DEFAULT_VALUE);
            fieldData.BENEFICIARY_TEL && (fieldData.BENEFICIARY_TEL.DEFAULT_VALUE = legalFields.LEGAL_MOBILE_TEL.DEFAULT_VALUE || legalFields.LEGAL_PERSON_TEL.DEFAULT_VALUE);
            _this.$nextTick(function () {
              fieldData.BENEFICIARY_ID && (fieldData.BENEFICIARY_ID.DEFAULT_VALUE = legalFields.LEGAL_REP_ID_CODE.DEFAULT_VALUE);
              bizBenefitMethod.checkBeneficiaryId(_this, field, fieldData, md, "0", "0");
            });
          } else {
            fieldData.BENEFICIARY_TYPE && (fieldData.BENEFICIARY_TYPE.FIELD_CONTROL = "0");
            if (noClean === "0") {
              fieldData.BENEFICIARY_NAME && (fieldData.BENEFICIARY_NAME.DEFAULT_VALUE = "");
              fieldData.BENEFICIARY_ID_TYPE && (fieldData.BENEFICIARY_ID_TYPE.DEFAULT_VALUE = "");
              fieldData.BENEFICIARY_EXP_DATE && (fieldData.BENEFICIARY_EXP_DATE.DEFAULT_VALUE = "");
              fieldData.BENEFICIARY_ID && (fieldData.BENEFICIARY_ID.DEFAULT_VALUE = "");
              fieldData.BENEFICIARY_TEL && (fieldData.BENEFICIARY_TEL.DEFAULT_VALUE = "");
            }
          }
        }
      }
    }
  },
  "CHECK_BENEFICIARY_ID_TYPE": function CHECK_BENEFICIARY_ID_TYPE(_this, field, fieldData, moduleObj, index, isAuto) {
    if (bizBenefitMethod.isLFieldDict(fieldData)) {
      return;
    }
    fieldData["BENEFICIARY_ID"] && (fieldData["BENEFICIARY_ID"].VALID_TYPE = _this.$blMethod.getIdCodeValidType(field.DEFAULT_VALUE));
    fieldData["BENEFICIARY_ID"].DEFAULT_VALUE = "";
    bizBenefitMethod.checkBeneficiaryIdType(_this, field, fieldData, moduleObj, index, isAuto);
  },
  "CHECK_BENEFICIARY_ID": function CHECK_BENEFICIARY_ID(_this, field, fieldData, moduleObj, index, isAuto) {
    if (field.LAST_DEFAULT_VALUE === field.DEFAULT_VALUE) {
      return;
    }

    if (bizBenefitMethod.isLFieldDict(fieldData)) {
      return;
    }
    bizBenefitMethod.checkBeneficiaryId(_this, field, fieldData, moduleObj, index, isAuto);

    field.LAST_DEFAULT_VALUE = field.DEFAULT_VALUE;
    field.DEFAULT_VALUE && _this.$blMethod.isDisabledLongTime(_this, fieldData.BENEFICIARY_ID_TYPE.DEFAULT_VALUE, field.DEFAULT_VALUE, fieldData.BENEFICIARY_EXP_DATE);
  },

  "CHECK_BENEFICIARY_TYPE": function CHECK_BENEFICIARY_TYPE(_this, field, fieldData, moduleObj, index, isAuto) {
    bizBenefitMethod.checkBeneficiaryType(_this, field, fieldData, _this.groupDatas.CONTROLER_INFO_PAGE.BENEFICIARY_MODULE, index, isAuto, moduleObj);
  },

  "CHECK_BENEFICIARY_TYPE__CLICK": function CHECK_BENEFICIARY_TYPE__CLICK(_this, field, fieldData, moduleObj, index, isAuto) {
    bizBenefitMethod.checkBeneficiaryTypeClick(_this, field, fieldData, moduleObj, index, isAuto);
  },

  "CHECK_ACT_CTRL_CPNY": function CHECK_ACT_CTRL_CPNY(_this, field, fieldData, moduleObj, index, isAuto) {
    bizBenefitMethod.checkBeneficiaryControlMethod(_this, field, fieldData, moduleObj, index, isAuto);
  },

  "CHECK_IS_UPLOAD_IMG": function CHECK_IS_UPLOAD_IMG(_this, field, fieldData, moduleObj, index, isAuto) {
    bizBenefitMethod.checkUploadPublicPhoto(_this, field, fieldData, moduleObj, index, isAuto);
  },

  "moduleCustomizeWithoutChange": function moduleCustomizeWithoutChange(_this, moduleId, moduleObj, isChecked, moduleArr, el) {
    return bizBenefitMethod.checkWithoutChange(_this, moduleId, moduleObj, isChecked, moduleArr, el);
  },

  "moduleCustomizeSameChange": function moduleCustomizeSameChange(_this, moduleId, moduleObj, isChecked, moduleArr, el) {
    return bizBenefitMethod.checkSameChange(_this, moduleId, moduleObj, isChecked, moduleArr, el);
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizControl/bizBeneficiaryInfoNode.js
// module id = 159
// module chunks = 2